import DocumentationButton from "components/DocumentationButton";
import { LogoAnsible } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";
import { getDocsUrl } from "utils/getDocsUrl";

type ConfigManagementEmptyStateProps = {
  title?: string;
  caption?: string;
};

const ConfigManagementEmptyState = ({
  title = "You don’t have any Ansible tasks yet",
  caption = "You can use Spacelift to monitor and manage your configuration",
}: ConfigManagementEmptyStateProps) => (
  <EmptyState title={title} caption={caption} icon={LogoAnsible}>
    {/* TODO: docs link */}
    <DocumentationButton to={getDocsUrl("/vendors/ansible.html")} label="Documentation" />
  </EmptyState>
);

export default ConfigManagementEmptyState;
